import { ActionIcon, Text, Menu, ScrollArea } from "@mantine/core";
import { countries } from "./countries";
import { MdFlagCircle } from "react-icons/md";
import { useCountry } from "../../CountryContext";

export const CountrySelector = () => {
    const { country, setCountry } = useCountry();

    return (
        <Menu position="bottom-start" shadow="md" width={180}>
            <Menu.Target>
                <div style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                    <ActionIcon variant="subtle" color="dark.6" radius="lg">
                        <MdFlagCircle size={20} />
                    </ActionIcon>
                    <Text fw={600} tt="uppercase" c="dark.4">
                        {country}
                    </Text>
                </div>
            </Menu.Target>
            <Menu.Dropdown>
                <ScrollArea h={300}>
                    {countries
                        .toSorted((a, b) => a.isoCode.localeCompare(b.isoCode))
                        .map(c => (
                            <Menu.Item key={c.isoCode} onClick={() => setCountry(c.isoCode)}>
                                {c.name} ({c.isoCode})
                            </Menu.Item>
                        ))}
                </ScrollArea>
            </Menu.Dropdown>
        </Menu>
    );
};
